import React from 'react';
import { Link } from 'react-router-dom';

interface ArticleLayoutProps {
    title: string;
    subtitle: string;
    children: React.ReactNode;
}

export const ArticleLayout: React.FC<ArticleLayoutProps> = ({ title, subtitle, children }) => {
    return (
        <div className="page-container" style={{ maxWidth: '800px' }}>
            <section className="hero">
                <h1 className="hero-title">{title}</h1>
                <p className="hero-subtitle">{subtitle}</p>
            </section>

            <article className="card article-content" style={{ lineHeight: '1.6', fontSize: '1.1rem' }}>
                {children}
            </article>

            <section className="cta-section" style={{ textAlign: 'center', marginTop: '4rem', marginBottom: '4rem' }}>
                <h2 style={{ marginBottom: '1rem' }}>Ready to streamline your localization workflow?</h2>
                <Link to="/" className="button primary large">
                    Start Converting Now
                </Link>
            </section>
        </div>
    );
};
